// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2rAvU","paramInput":"JobSimulator_paramInput__1cTJo","input":"JobSimulator_input__16Sw7"};